import { ItemModel } from "./item";
import { ItemBrandModel } from "./item-brand";
import { ItemUnitModel } from "./item-unit";

export const SaleOrderDeliveryDetailModel = {
    item_id: 0,
    item: { ...ItemModel },
    item_name: '',
    item_brand_id: 0,
    item_brand: { ...ItemBrandModel },
    item_unit_id: 0,
    item_unit: { ...ItemUnitModel },
    quantity: 0,
    delivering_quantity: 0,
    brands: [],
    item_serials: []
}